<template>
  <v-tooltip bottom v-if="!!message">
    <template v-slot:activator="{ on, attrs }">
      <Button icon v-bind="attrs" v-on="on" class="tooltip-action" :v-ripple="false">
        <slot />
      </Button>
    </template>
    <span>{{ message }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "app-tooltip",

  props: {
    message: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.tooltip-action {
  display: inline !important;
  padding: 0 !important;
  margin: 0 !important;
  height: auto !important;
  width: auto !important;
  text-transform: inherit !important;
}
.v-tooltip__content {
  background: #2e2c2cde !important;
  font-family: "Roboto", "Almarai", sans-serif;
  font-size: 1.4rem !important;
  font-weight: 500;
  text-transform: capitalize;
  line-height: 1.8rem !important;
  opacity: 1 !important;
}
</style>
